<span class="feature-pill" [ngClass]="statusClass">
	<i class="material-icons" *ngIf="icon" aria-hidden="true">{{ icon }}</i>
	<span>{{ label }}</span>
</span>
